const baseUrl = '';

export default function dataSender(url, data, method){
    return fetch(
        baseUrl+url,
        {
            method: method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            mode: 'cors'
        }
    );
}

export function postCandidateFile(url, uploadData, customerName){
    let data = new FormData();
    data.append('file',  uploadData);
    return fetch(baseUrl+url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'X-Api-Key':  sessionStorage.getItem('apiKey-' + customerName)
        },
        body: data,
        mode: 'cors'
    });
}

export function dataGetter(url, language = 'en') {
    return fetch(
        baseUrl+url,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Accept-Language': language
            },
            mode: 'cors'
        }
    );
}

export function formGetter(url, language = 'en') {
    return fetch(
        url,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Accept-Language': language
            },
            mode: 'cors'
        }
    );
}

export function generateJobIconUrl(url, mongoId = '') {
    if (mongoId) {
        return baseUrl + '/api/v2/gate/images/' + mongoId;
    }

    if (url) {
        return baseUrl + '/api/v2/gate/images/' + url;
    }
    return '/gate/images/job/read-more.svg';
}
